module.exports = __webpack_public_path__ + "img/盘古大模型开发AI优势水印.587d39a4.png";